import { render } from "./DataPreview.vue?vue&type=template&id=670c4a56"
import script from "./DataPreview.vue?vue&type=script&lang=js"
export * from "./DataPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__